!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.cloudPak = t() : e.cloudPak = t();
}(window, function () {
  /******/
  return n = {},
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/
  o.m = r = [
  /* 0 */

  /***/
  function (e, t) {
    function v(e) {
      return (v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    /**
     * Returns whether the argument is an Object. Returns false for Arrays
     * @param {any} item - argument to check
     * @returns {boolean}
     */


    function d(e) {
      return !(b(e) || "object" !== v(e) || !e);
    }
    /**
     * Returns whether the argument is undefined
     * @param {any} item - argument to check
     * @returns {boolean}
     */


    function c(e) {
      return void 0 === e;
    }
    /**
     * Returns whether the argument is an Array
     * @param {any} a - argument to check
     * @returns {boolean}
     */


    function b(e) {
      return "[object Array]" == Object.prototype.toString.call(e);
    }
    /**
     * Returns whether the argument is null
     * @param {any} item - argument to check
     * @returns {boolean}
     */


    function n(e) {
      return null === e;
    }
    /**
     * Returns whether argument is a string
     * @param {any} item - argument to check
     * @returns {boolean}
     */


    function f(e) {
      return "string" == typeof e;
    }
    /**
     * Returns whether the argument is a Function.
     * @param {any} item - argument to check
     * @returns {boolean}
     */


    function r(e) {
      return "function" == typeof e;
    }
    /**
     * Enumerates properties of the object sent
     * and stringifies all Object type values.
     * @param {Object} obj - object to stringify
     * @returns {Object}
     */

    /**
     * Parses stringified JSON
     * If the argument sent is not JSON, then it will be returned as-is
     * @param {any} item - object to stringify
     * @param {any} [defaultValue] - default value if parseStringify fails
     * @returns {any} - parsed object
     */


    function s(e, t) {
      t = c(t) ? e : t;

      try {
        var r = JSON.parse(e);
        return d(r) || b(r) ? r : t;
      } catch (e) {
        return t;
      }
    }
    /**
     * Enumerates properties of the object sent
     * and parses all stringified objects.
     * @param {Object} object - object to stringify
     * @param {{flatten: boolean}} [options] options - object to stringify
     * @returns {Object} - parsed object
     */

    /**
     * Checks if the argument is empty.
     * Returns true for: {}, [], '', undefined, null, number
     * @param {Object} item - object to check
     * @returns {boolean}
     */


    function m(e) {
      return e && e.hasOwnProperty("length") ? !e.length : !d(e) || !Object.keys(e).length;
    }
    /**
     * Compares Two Objects For Deep Equality
     * @param {Object} obj1 - First Object
     * @param {Object} obj2 - Second Object
     * @returns {boolean}
     */

    /*
     * Helper function for get that recursively
     * traverses an object based on the path array
     * and returns the value at the path
     * returns when the end of the path is reached
     * or a falsey value is found
     */


    function a(e, t, r, n) {
      var o = t.shift();
      if (c(o)) return n;

      var u,
          i =
      /*
       * Parses prop as an array index from a path string
       * Returns undefined when prop is not an index
       */
      function (e) {
        var t,
            r = e.length - 1;
        return "]" === e[r] ? t = +e.slice(0, r) : isNaN(e) || (t = +e), t;
      }(o);

      if ((u = "*" === o ? e : c(i) ? e[o] : e[i]) && t.length) return a(u, t, r, n);
      if (r) if (u) try {
        "function" != typeof u && (u = p(u)), u = r(u);
      } catch (e) {
        console.log(e), u = n;
      } else u = n;
      return u;
    }
    /**
     * Gets the value at a given path in an object
     * Returns an optional default value if the path
     * doesn't exist or if the values is falsey
     * A mutator function can be optionally sent and will run
     * when the value is found.
     * Passing '*' as the path will return the object unchanged
     * @param {object|string|Array<any>} obj - object to parse
     * @param {string|number|Array<string|number>} path - path to desired value
     * @param {any} [defaultValue] - default value
     * @param {Function} [mutator] - mutator function
     * @returns {any}
     */


    function l(e, t, r, n) {
      if (b(t) || (t = "" + t), !(t && e && (d(e) || b(e) || f(e)))) return r;
      var o = a(e,
      /*
       * Used to parse the path for set and get
       */
      function (e) {
        return b(e) || "" === (e = e.split(/\.|\[/))[0] && e.shift(), e;
      }(t), n, r);
      return n ? o : o || r;
    }
    /**
     * Invokes the iteratee n times,
     * returning an array of the results of each invocation.
     * The iteratee is invoked with one argument; (index)
     * @param {number} n -  The number of times to invoke iteratee.
     * @param {Function} func -  The function invoked per iteration.
     * @returns {Array}: Returns the array of results.
     */

    /**
     * Deeply Clones an object or array
     * @param {any} item -  item to clone
     * @returns {any}: cloned item
     */


    function p(e) {
      return JSON.parse(JSON.stringify(e));
    }
    /**
     * Flattens an array
     * @param {Array} array -  array to flatten
     * @returns {Array}: flattened array
     */


    function o(e) {
      return e.replace(/[\W_]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z])([a-z])/g, "$1$2").replace(/([A-Z])([a-z])/g, " $1$2").replace(/([_0-9])([a-zA-Z])/g, "$1 $2").replace(/([a-zA-Z])([_0-9])/g, "$1 $2").split(" ");
    }
    /**
     * Splits string into an array of its words
     * @param {String} string - String to convert
     * @returns {Array}: Return array of words
     */

    /**
     * Creates an array with all falsey values removed. The values false, null, 0, "", undefined, and NaN are falsey.
     * Results of each compacted array is an array with all truthy values
     * @param {Array} array - item to compact
     * @returns {Array} - result of compaction 
     */


    function u(e) {
      return b(e) ? e.reduce(function (e, t) {
        return t && e.push(t), e;
      }, []) : e;
    }
    /**
     * Converts any string to start case
     * @param {String} string - The string to convert
     * @returns {String}: Returns a start cased string
     */

    /**
     * Circular Replacer Function for JSON.stringify - Causes data loss on circular reference
     * @param {String} string - The string to convert
     * @returns {Function}: Returns a function that alters JSON.stringify by replacing circular references
     */


    function i() {
      var r = new WeakSet();
      return function (e, t) {
        if ("object" === v(t) && null !== t) {
          if (r.has(t)) return;
          r.add(t);
        }

        return t;
      };
    }
    /**
     * Error Formatter for Apollo Server that removes circular references and logs the error
     * @param {Object} error - The Error to be logged and safely returned
     * @returns {Object}: Returns the error without circular references
     */

    /**
     * Returns whether the argument is a number, this function will return false for NaN
     * @param {any} n - arguments to check 
     * @returns {boolean}
     */


    function g(e) {
      return "number" == typeof e && !Number.isNaN(e);
    }
    /**
     * Compares two items for deep equality. Supports strings, numbers, arrays, and objects
     * @param {Any} item1 - First item to compare 
     * @param {Any} item2 - Second item to compare 
     * @returns {Boolean}: Returns a boolean after determining whether the two items are deeply equal 
     */


    function h(e, o) {
      return v(e) === v(o) && ("object" !== v(e) ? e === o : !(!m(e) || !m(o)) || (b(e) ? e.reduce(function (e, t, r) {
        var n = o[r];
        return d(t) ? x(t, n) : b(t) && b(n) ? h(t, n) : e && t === n;
      }, !0) : x(e, o)));
    }

    function x(r, n) {
      if (v(r) !== v(n)) return !1;
      if (!d(r) || !d(n)) return !1;
      var e = Object.keys(r),
          t = Object.keys(n);
      return e.length === t.length && e.reduce(function (e, t) {
        return d(r[t]) && d(n[t]) ? x(r[t], n[t]) : b(r[t]) ? h(r[t], n[t]) : e && r[t] === n[t];
      }, !0);
    }
    /**
     * Creates a new object from the source object and sets the value at path of object. If a portion of path doesn't exist, it's created. Arrays are created for missing index properties while objects are created for all other missing properties. To append to an array, rather than write at a particular index, pass no index into the [], i.e. `a.b[]`
     * @param {Object} obj - Object to modify 
     * @param {Array|String} path - The path of the property to set.
     * @param {Any} value - Value to set for obj at end of path
     * @returns {Object}: Returns the modified object with the newly created path
     */


    e.exports.isObject = d, e.exports.isUndefined = c, e.exports.isNull = n, e.exports.isString = f, e.exports.isFunction = r, e.exports.stringifyObjectValues = function (r) {
      return r && d(r) ? Object.keys(r).reduce(function (e, t) {
        return d(r[t]) ? e[t] = JSON.stringify(r[t]) : e[t] = n(r[t]) ? void 0 : r[t], e;
      }, {}) : r;
    }, e.exports.parseStringifiedObject = function o(e, u) {
      var i = Object.assign({}, e);
      return Object.keys(i).reduce(function (t, r) {
        if (f(i[r])) try {
          var n = JSON.parse(i[r]);
          u && u.flatten && d(n) ? (delete i[r], Object.keys(n).forEach(function (e) {
            t[e] = n[e];
          })) : d(n) && n.sendStringified ? t[r] = n.value : t[r] = "object" === v(n) ? n : i[r];
        } catch (e) {
          t[r] = i[r];
        } else if (d(i[r])) {
          var e = i[r];
          e.sendStringified ? t[r] = e.value : t[r] = o(i[r], u);
        } else b(i[r]) ? t[r] = i[r].map(function (e) {
          return d(e) ? o(e, u) : s(e);
        }) : t[r] = i[r];
        return t;
      }, {});
    }, e.exports.parseStringifiedJSON = s, e.exports.isEmpty = m, e.exports.compare = function (e, t) {
      return JSON.stringify(e) === JSON.stringify(t);
    }
    /**
     * Returns an array of unique values.
     * An iteratable function can be sent to perform
     * the comparison. Otherwise it compares each item as is.
     * @param {Array<any>} arr - Array to search
     * @param {Function} [iteratee] - The iteratee invoked per element.
     * @returns {Array<any>}
     */
    , e.exports.isArray = b, e.exports.LinkedList =
    /** @class */
    function () {
      function i(e) {
        this.element = e, this.next = null;
      }
      /**
         * @prop {number}
         */


      this.length = 0;
      var c = null;
      /**
         * Returns the current node
         * @returns {any} Returns the resolved value.
         */

      this.head = function () {
        return c;
      },
      /**
         * Adds an element to the end of the linked list
         * @param {any} element The object to query.
         */
      this.add = function (e) {
        var t = new i(e);
        if (n(c)) c = t;else {
          for (var r = c; r.next;) {
            r = r.next;
          }

          r.next = t;
        }
        this.length++;
      },
      /**
         * Removes element from linked list
         * @param {any} element The object to query.
         */
      this.remove = function (e) {
        var t,
            r = c;
        if (r.element === e) c = r.next;else {
          for (; r.element !== e;) {
            r = (t = r).next;
          }

          t.next = r.next;
        }
        this.length--;
      },
      /**
         * Returns whether the list is empty
         * @returns {boolean} List is empty
         */
      this.isEmpty = function () {
        return !this.length;
      },
      /**
         * Returns the index of the element
         * @param {any} element element to get index of
         * @returns {number} index of element
         */
      this.indexOf = function (e) {
        for (var t = c, r = -1; t;) {
          if (r++, t.element === e) return r;
          t = t.next;
        }

        return -1;
      },
      /**
         * Returns the element at a specified index
         * @param {number} index index of element
         * @returns {any} element at index
         */
      this.elementAt = function (e) {
        for (var t = c, r = 0; r < e;) {
          r++, t = t.next;
        }

        return t.element;
      },
      /**
         * Adds an element at a specified index
         * @param {number} index index
         * @param {any} element element
         */
      this.addAt = function (e, t) {
        var r,
            n = new i(t),
            o = c,
            u = 0;
        if (e > this.length) return !1;

        if (e) {
          for (; u < e;) {
            u++, o = (r = o).next;
          }

          n.next = o, r.next = n;
        } else n.next = o, c = n;

        this.length++;
      },
      /**
         * Removes the element at a specified index
         * @param {number} index index
         */
      this.removeAt = function (e) {
        var t,
            r = c,
            n = 0;
        if (e < 0 || e >= this.length) return null;

        if (e) {
          for (; n < e;) {
            n++, r = (t = r).next;
          }

          t.next = r.next;
        } else c = r.next;

        return this.length--, r.element;
      },
      /**
         * Returns the list as an array
         * @returns {Array} array of list items
         */
      this.toArray = function () {
        for (var e = c, t = [e.element]; e.next;) {
          e = e.next, t = t.concat(e.element);
        }

        return t;
      };
    }
    /**
    * Composes a function that returns the result of invoking the given functions,
    * where each successive invocation is supplied the return value of the previous.
    * @param {...Function} funcs The functions to invoke.
    * @returns {Function} Returns the new composite function.
    */
    , e.exports.times = function (e, t) {
      for (var r = [], n = -1; ++n < e;) {
        r.push(t(n));
      }

      return r;
    }
    /**
     * Converts number into formatted money string
     * negative denotated by parenthesis
     * ($1.23) === -1.23
     * @param {number | string} amount -  Amount to format
     * @param {boolean} [noToFixed] -  If true, toFixed(2) wont be applied
     * @returns {string}: Returns the result.
     */
    , e.exports.uniq = function (e, t) {
      var n = {},
          o = t || function (e) {
        return e;
      };

      return e.reduce(function (e, t) {
        var r = JSON.stringify(o(t));
        return n[r] || (n[r] = !0, e.push(t)), e;
      }, []);
    }, e.exports.get = l, e.exports.formatMoney = function (e, t) {
      var r = f(e) ? parseFloat(e) : e,
          n = r < 0,
          o = n ? ")" : "",
          u = n ? -1 * r : r;
      return (n ? "($" : "$") + (t ? "" + u : u.toFixed(2)) + o;
    }, e.exports.cloneDeep = p, e.exports.flatten = function (e) {
      return e.reduce(function (t, e) {
        return b(e) ? e.forEach(function (e) {
          t.push(e);
        }) : t.push(e), t;
      }, []);
    }
    /**
     * Recursively flattens array of any depth
     * @param {Array} arr - array to flatten
     * @returns {Array}: flattened array
     */
    , e.exports.flattenDeep = function (e) {
      if (!b(e)) return e;
      var t = [];
      return function t(e, r) {
        result = r || [];
        e.forEach(function (e) {
          Array.isArray(e) ? t(e, result) : result.push(e);
        }, []);
      }(e, t), t;
    }, e.exports.removeKey =
    /**
     * Removes the key from a deeply nested object
     * @param {Array | Object} obj -  object or array to traverse
     * @param {string} keyToDelete - key to delete from item
     * @returns {Array | Object}: item with key removed
     */
    function (e, t) {
      return function t(r, n, o) {
        return d(r) || b(r) ? (b(r) ? o = r.map(function (e) {
          return t(e, n);
        }) : (o = o || {}, Object.keys(r).forEach(function (e) {
          e !== n && (o[e] = t(r[e], n, o[e]));
        })), o) : r;
      }(e, t);
    }
    /**
     * Stringifies an item any number of times.
     * Results of each stringification is used as the value
     * to stringify for the next iteration
     * @param {any} item -  item to stringify
     * @param {number} [times] - number of times to stringify. Defaults to 1
     * @returns {String}: result of stringification
     */
    , e.exports.stringify = function (t, e) {
      var r = 0,
          n = e || 1,
          o = t;

      try {
        for (; r < n;) {
          r++, o = JSON.stringify(o);
        }

        return o;
      } catch (e) {
        return console.log(e), t;
      }
    }, e.exports.objectValueUndefinedToNull =
    /**
     * Deeply converts all undefined values in an object to null
     * @param {object} obj -  obj to convert
     * @returns {object}: result of conversion
     */
    function (e) {
      return d(e) ? function n(o) {
        return d(o) ? Object.keys(o).reduce(function (e, t) {
          var r = o[t];
          return e[t] = c(r) ? null : r, d(r) ? e[t] = n(r) : b(r) && (e[t] = r.map(function (e) {
            return n(e);
          })), e;
        }, {}) : o;
      }(e) : e;
    }
    /**
     * Camelcases any string
     * Result of each camelcasing is a string unless provided a different datatype
     * @param {String} string - String to camelcase
     * @returns {String}: result of camelcasing   
     */
    , e.exports.camelCase = function (e) {
      return !f(e) || /^[a-zA-Z]+$/.test(e) && e[0] === e[0].toLowerCase() ? e : e.replace(/[\W_0-9]+/g, " ").split(" ").reduce(function (e, t) {
        return e ? e + t.charAt(0).toUpperCase() + t.substr(1) : e + t.charAt(0).toLowerCase() + t.substr(1);
      }, "");
    }, e.exports.constCase =
    /**
     * Converts a string to const case
     * @param {String} string - String to convert 
     * @returns {String}: Returns a const-cased string
     */
    function (e) {
      return f(e) ? o(e).reduce(function (e, t) {
        var r = t.toUpperCase();
        return e ? t ? e + "_" + r : e : r;
      }, "") : e;
    }
    /**
     * Wrapper function that will delay invoking a function for the specified time
     * @param {Function} fn - Function to debounce
     * @param {Number} delay - Amount of time to delay in milliseconds 
     * @return {Any}: Returns the result of the function
     */
    , e.exports.compact = u, e.exports.startCase = function (e) {
      return f(e) ? o(e).reduce(function (e, t) {
        var r = t.charAt(0).toUpperCase() + t.substr(1);
        return e ? t ? e + " " + r : e : r;
      }, "") : e;
    }, e.exports.words = function (e) {
      return u(o(e));
    }, e.exports.getCircularReplacer = i, e.exports.formatError = function (e) {
      var t = JSON.stringify(e, i());
      return console.error(t), JSON.parse(t);
    }
    /**
     * Checks whether or not the string is JSON
     * @param {String} string - String to validate
     * @returns {Boolean}: Returns boolean evaluation of string
     */
    , e.exports.isStringifiedJson = function (e) {
      if (!f(e)) return !1;

      try {
        return !!JSON.parse(e);
      } catch (e) {
        return !1;
      }
    }
    /**
     * Checks if path is a direct property of object
     * @param {Object} obj - Object to query
     * @param {Array | String} path - Path to check 
     * @returns {boolean} - Result of validation
     */
    , e.exports.has = function (e, t) {
      return d(e) && (f(t) || b(t)) ? !!(b(t) ? t : t.split(".")).reduce(function (e, t) {
        return e && e[t];
      }, e) : e;
    }
    /** 
     * Converts the first character of string to upper case and the remaining to lower case.
     * @param {String} string - String to capitalize
     * @returns {String} - Return capitalized string 
     */
    , e.exports.capitalize = function (e) {
      return f(e) ? e[0].toUpperCase() + e.substr(1).toLowerCase() : e;
    }, e.exports.create =
    /**
     * Creates an object that inherits from the prototype object. If a properties object is given, its own enumerable string keyed properties are assigned to the created object.
     * @param {Object} prototype - Object to inherit from
     * @param {Object} properties - Properties to assign to object
     * @returns {Object}: Returns new object with the newly assigned properties
    */
    function (e, t) {
      if (!d(e) && !d(t)) return e;
      var r = Object.create(e);

      for (var n in t) {
        r[n] = t[n];
      }

      return r;
    }, e.exports.merge =
    /** 
     * Recursively merges own and inherited enumerable string keyed properties of source objects into the destination object. 
     * @param {Object | Array} src - The destination object.
     * @param {Object | Array} item - The object/array being merged
     * @returns {Object | Array}: Returns a newly merged object/array
     */
    function (e, t) {
      if ("object" !== v(e) || !e) return e;
      var r = p(e);
      return function e(t, r) {
        if ("object" !== v(r) || !r) return t;

        for (var n in r) {
          r[n] && ("object" === v(r[n]) && r[n] ? "object" === v(t[n]) && t[n] ? e(t[n], r[n]) : t[n] = e(b(r[n]) ? [] : {}, r[n]) : t[n] = r[n]);
        }

        return t;
      }(r, t), r;
    }, e.exports.isNumber = g, e.exports.upperFirst =
    /**
     * Converts the first character of string to upper case. Similar to capitalize but will not lowercase the rest of the string
     * @param {String} string - String to uppercase
     * @returns {String} - Uppercased string
     */
    function (e) {
      return f(e) ? e[0].toUpperCase() + e.substr(1) : e;
    }, e.exports.last =
    /**
     * Gets the last element of array or string
     * @param {String|Array} item - Source string / array
     * @returns {any}: Returns the last element of the source string/array 
     */
    function (e) {
      return !f(e) && !b(e) || m(e) ? e : e[e.length - 1];
    }, e.exports.isMatch =
    /**
     * Performs a partial deep comparison between object and source to determine if object contains equivalent property values.
     * If passed either a string or number, only an unstrict equality comparison is performed 
     * When comparing an object with either an empty array or empty object, the result will always be true
     * @param {any} obj - Item to evaluate against
     * @param {any} match - Item to compare
     * @return {boolean}: Result of matching 
     */
    function (e, t) {
      var r = !0,
          n = d(e),
          o = b(e),
          u = d(t),
          i = b(t),
          c = m(t);
      if (n && i && !c || o && u && !c) return !1;
      if ("object" !== v(e)) return e == t;

      for (var f = u ? Object.keys(t).length : t.length, s = 0; r && s < f;) {
        var a = u ? Object.keys(t)[s] : s,
            l = d(e[a]),
            p = d(t[a]),
            g = m(t[a]);
        if (i && l && p && !g) for (var h = Object.keys(t[s]), x = 0; r && x < h.length;) {
          var y = h[x];
          e[s][y] != t[s][y] && (r = !1), x++;
        } else if (!(l && p && g)) {
          (u ? e[a] : e.indexOf(t[s])) != (u ? t[a] : t.indexOf(t[s])) && (r = !1);
        }
        s++;
      }

      return r;
    }, e.exports.isNil =
    /**
     * Checks whether the item is null or undefined
     * @param {any} item - Item to validate 
     * @returns {Boolean}: Boolean evaluation whether the item is null/undefined
     */
    function (e) {
      return n(e) || void 0 === e;
    }, e.exports.lowerCase =
    /**
     * Converts a string, of space/symbol/case/integer separated words, to lower case.
     * @param {String} string - String to convert
     * @returns {String}: returns a lowercased string
     */
    function (e) {
      return f(e) ? o(e).reduce(function (e, t) {
        var r = t.toLowerCase();
        return e ? t ? e + " " + r : e : r;
      }, String()) : e;
    }, e.exports.isEqual = h, e.exports.set = function (e, t, u, r) {
      if (!d(e) || !f(t) && !b(t)) return e;
      var n = t;
      f(t) && (n = n.replace(/[\[\']/g, ".").replace(/[\]']/g, ""));
      var i = b(t) ? n : n.split("."),
          o = l(r, "mutate") ? e : p(e);
      return i.reduce(function (e, t, r) {
        var n = r === i.length - 1,
            o = i[r + 1];
        return "" === t ? (e = e || [], n ? e.push(u) : e.push(isNaN(o) ? {} : []), e[e.length - 1]) : (e[t] || (isNaN(o) ? e[t] = {} : e[t] = []), n && (e[t] = u), e && e[t]);
      }, o), o;
    }, e.exports.kebabCase =
    /**
     * Converts a string to kebabCase i.e 'foo-bar'
     * @param {String} string - String to convert 
     * @returns {String} - Returns kebab-cased string
     */
    function (e) {
      return o(e).reduce(function (e, t) {
        var r = t.charAt(0).toLowerCase() + t.substr(1).toLowerCase();
        return e ? t ? e + "-" + r : e : r;
      }, String());
    }, e.exports.titleCase =
    /**
     * Converts a string to title case excluding minor words i.e 'in, of, or'
     * @param {String} string - String to convert 
     * @returns {String} - Returns title cased string
     */
    function (e) {
      if (!f(e)) return e;
      var i = ["at", "for", "in", "into", "of", "on", "to", "as", "if", "or", "and"],
          c = o(e);
      return c.reduce(function (e, t, r) {
        var n = t.charAt(0).toUpperCase() + t.substr(1),
            o = t.toLowerCase(),
            u = i.includes(o) && r !== c.length - 1 ? o : n;
        return e ? t ? e + " " + u : e : n;
      }, String());
    }, e.exports.debounce = function (n, o) {
      var u;
      if (r(n) && g(o)) return function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e.push(arguments[t]);
        }

        var r = this;
        u && clearTimeout(u), u = setTimeout(function () {
          n.apply(r, e);
        }, o);
      };
    }, e.exports.Logger = new
    /** @class */
    function () {
      /**
         * @param {{loggerOptions: { stringifyAll: Boolean } }} [options] options - Option to stringify all arguments before outputting them to the console
         * @return {Boolean}: Returns true if successful
         */
      this.log = function () {
        for (var e = arguments[arguments.length - 1].loggerOptions, t = e && e.stringifyAll, r = 0; r < arguments.length - 1; r++) {
          t ? (console.log(JSON.stringify(arguments[r])), console.log("All arguments have been stringified")) : console.log(arguments[r]);
        }

        return !0;
      },
      /**
        * @param {{loggerOptions: { stringifyAll: Boolean } }} [options] options - Option to stringify all arguments before outputting them to the console
        * @return {Boolean}: Returns true if successful
        */
      this.error = function () {
        for (var e = arguments[arguments.length - 1].loggerOptions, t = e && e.stringifyAll, r = 0; r < arguments.length - 1; r++) {
          t ? (console.error(JSON.stringify(arguments[r])), console.log("All arguments have been stringified")) : console.error(arguments[r]);
        }

        return !0;
      };
    }(), e.exports.compose = function () {
      for (var e = arguments.length, u = new Array(e), t = 0; t < e; t++) {
        u[t] = arguments[t];
      }

      if (u.reverse(), u.every(function (e) {
        return r(e);
      }) && !c(u)) {
        var i = u ? u.length : 0;
        return function () {
          for (var e = 0, t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          for (var o = i ? u[e].apply(null, r) : r[0]; ++e < i;) {
            o = u[e].call(null, o);
          }

          return o;
        };
      }
    };
  }
  /******/
  ],
  /******/

  /******/
  // expose the module cache

  /******/
  o.c = n,
  /******/

  /******/
  // define getter function for harmony exports

  /******/
  o.d = function (e, t, r) {
    /******/
    o.o(e, t) ||
    /******/
    Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
    /******/
  },
  /******/

  /******/
  // define __esModule on exports

  /******/
  o.r = function (e) {
    /******/
    "undefined" != typeof Symbol && Symbol.toStringTag &&
    /******/
    Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    })
    /******/
    , Object.defineProperty(e, "__esModule", {
      value: !0
    });
  },
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/
  o.t = function (t, e) {
    /******/
    if (
    /******/
    1 & e && (t = o(t)), 8 & e) return t;
    /******/

    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    /******/

    var r = Object.create(null);
    /******/

    /******/

    if (o.r(r),
    /******/
    Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) {
      o.d(r, n, function (e) {
        return t[e];
      }.bind(null, n));
    }
    /******/

    return r;
    /******/
  },
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/
  o.n = function (e) {
    /******/
    var t = e && e.__esModule ?
    /******/
    function () {
      return e.default;
    } :
    /******/
    function () {
      return e;
    };
    /******/

    /******/

    return o.d(t, "a", t), t;
    /******/
  },
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/
  o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  },
  /******/

  /******/
  // __webpack_public_path__

  /******/
  o.p = "", o(o.s = 0);
  /******/

  /******/
  // The require function

  /******/

  function o(e) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (n[e])
      /******/
      return n[e].exports;
    /******/

    /******/
    // Create a new module (and put it into the cache)

    /******/

    var t = n[e] = {
      /******/
      i: e,

      /******/
      l: !1,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    /******/

    /******/
    // Return the exports of the module

    /******/

    return r[e].call(t.exports, t, t.exports, o),
    /******/

    /******/
    // Flag the module as loaded

    /******/
    t.l = !0, t.exports;
    /******/
  }

  var r, n;
  /************************************************************************/

  /******/
});